import { css } from '@emotion/react';
import { SpacingToken } from '@livechat/design-system-react-components';

export const goToTheProductsText = css`
  margin: 0 0 var(${SpacingToken.Spacing3}) 0;
  width: fit-content;
`;

export const goToOtherProductsText = css`
  display: flex;
  margin-top: 0;
  margin-bottom: var(${SpacingToken.Spacing3});
`;

export const goToProductButtonsContainer = css`
  display: flex;
  flex-wrap: wrap;
  gap: var(${SpacingToken.Spacing3}) var(${SpacingToken.Spacing2});
`;

export const currentProductTitle = css`
  display: flex;
  align-items: center;
  gap: var(${SpacingToken.Spacing1});

  > p {
    margin: 0;
  }
`;
